import React from "react";
import "./HousekeepingServices.css";

// 👉 Replace with your own small icon
import ServiceIcon from "../../Image/HouseKeeping/rightthick.png";

const services = [
"Tea & coffee preparation",
  "Beverage distribution to desks",
  "Conference room refreshments",
  "Guest & VIP handling",
  "Cutlery & crockery management",
  "Pantry equipment cleaning",
  "Counter & surface sanitization",
  "Stock monitoring & alerts",
  "Consumables coordination",
  "Water dispenser management",
  "Microwave & appliance upkeep",
  "Waste disposal from pantry"
];

const steps = [
  {
    number: "01",
    title: "Requirement Analysis",
    desc: "Understand your office size, employee count, beverage preferences, and service expectations",
  },
  {
    number: "02",
    title: "Staff Deployment",
    desc: "Deploy trained pantry personnel with proper hygiene certification and hospitality training"
  },
  {
    number: "03",
    title: "Daily Operations",
    desc: "Regular beverage service, pantry maintenance, stock management, and quality service delivery",
  },
  {
    number: "04",
    title: "Continuous Improvement",
    desc: "Gather feedback, monitor service levels, and implement improvements for better satisfaction",
  },
];

const PantryServices = () => {
  return (
    <>
      {/* ---------------- SERVICES SECTION ---------------- */}
      <section className="hk-services-section">
        <h2 className="hk-section-title">Our Service Includes</h2>

        <div className="hk-services-grid">
          {services.map((item, index) => (
            <div key={index} className="hk-service-card">
              <img src={ServiceIcon} alt="service" className="hk-service-img" />
              <span>{item}</span>
            </div>
          ))}
        </div>
      </section>

      {/* ---------------- PROCESS SECTION ---------------- */}
      <section className="hk-process-section">
        <div className="hk-process-tag">Our Process</div>
        <h2 className="hk-section-title">Our Pantry Service Process</h2>

        <div className="hk-process-grid">
          {steps.map((step, index) => (
            <div key={index} className="hk-process-card">
              <div className="hk-process-number">{step.number}</div>
              <h4>{step.title}</h4>
              <p>{step.desc}</p>
            </div>
          ))}
        </div>
      </section>
    </>
  );
};

export default PantryServices;
